/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, themeV2, coloredScrollBar, pxToEm } from '@insticator/insticator-ui';
import { url } from 'utils/urls';



/* ++++++++++ --------------- DASHBOARD : STYLES --------------- ++++++++++ */
export default {
	'@global': {
    '.name-insticator-icon': {
      backgroundImage: `url(${url.image}/2.0/logos/pub_icon_color_dark.png) !important`,
    },
    '.name-insticator': {
      backgroundImage: `url(${url.image}/2.0/logos/pub_gradient_dark.png) !important`,
    },
		'body': {
			overflow: 'hidden' // to hide the extra scrollbar caused by the dashboard height extra 1px
		},
    '.intercom-lightweight-app-launcher': {
      background: `${themeV2.color.primary.main} !important`
    },
    '.multiselectdropdown': {
      '& .items': {
        height: 'initial !important',
        minHeight: `${pxToEm(120)} !important`,
        maxHeight: `${pxToEm(240)} !important`,
        '& .sublist': {
          paddingBottom: `0 !important`
        }
      }
    },
		'.tippy-tooltip-content': {
			wordBreak: 'initial !important',
      '& a': { textDecoration: 'underline !important' }
		},
    'input[type="text"]:disabled': {
      color: themeV2.color.base.gray.dark,
      opacity: 0.5
    },
    '.modalpage': {
      boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.16) !important',
      borderRadius: pxToEm(8),
      border: 0,
      '& .close': {
        animation: 'none !important',
        border: '0 !important',
        top: '10px !important',
        right: '8px !important',
        '& .icon':{
          color:  `${themeV2.color.primary.main} !important`
        }
      }
    }
	},
	dashboard: {
		width: '100%',
		height: `calc(100vh + 1px)`,
		overflow: 'hidden',
		display: 'flex',
		position: 'absolute',
		flexWrap: 'nowrap',
		flexDirection: 'row',
		'& #mainarea': {
            display: 'flex',
            flex: '1',
            flexDirection: 'column',
            overflow: 'hidden',
            '& #body': {
            	background: themeV2.color.background.light.blue,
            	flex: '1',
            	position: 'relative',
            	zIndex: '1',
            	'& .page': {
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
					position: 'absolute',
					width: '100%',
					height: '100%',
	            	'& #content': {
	            		background: 'transparent',
	            		padding: replacePXinStringWithEM(`56px 30px`),
	            		overflow: 'auto', // scroll only this content area,
                  extend: coloredScrollBar(themeV2.color.base.scrollbar)
	            	}
	            }
            }
        },
    '& .field': {
      '& > .label': {
        color: themeV2.color.primary.main,
        fontWeight: 700,
        marginBottom: pxToEm(8)
      }
    },
    '& label.label': { 
      color: themeV2.color.primary.main,
      fontWeight: 700,
      marginBottom: pxToEm(8),
      display: 'block'
     },
    '& .incontentmessage': {
      padding: 0,
      margin: `${pxToEm(16)} 0 ${pxToEm(24)}`
    },
    '& .errormessage': {
      opacity: '0',
      display: 'block',
      color: themeV2.color.error.main,
      fontSize: pxToEm(14),
      marginTop: pxToEm(5),
      // animate in 
      animationName: 'fadeInDown',
      animationDelay: '0s',
      animationDuration: '.1s',
      animationFillMode: 'forwards'
    },
    '& .switch': {
      '&.active-true': {
        '&.isStatic-true': {
          background: '#3257EC',
          opacity: 0.5
        }
      }
    },
    '& .configbutton': {
      background: '#FFF',
      color: '#061240',
      border: '1px solid #061240',
      width: 'auto'
	  }
  }
}